<template>
  <div class="bg-white p-y-4 m-b-3">
    <div class="container p-y-2 bg-gray20 p-x-4 p-x-2:mo">
      <div class="h2 text-bold m-b-2 c-gray90" selenium="job-details-title">
        <slot name="title"/>
      </div>
      <div class="h6 c-gray60 m-b-3">
        <slot name="subtitle"/>
      </div>
      <div v-if="$slots.content" class="m-t-2">
        <slot name="content"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'job-request-pane',
};
</script>
